<!-- Показывает ссылку на заказ в компонентном форматтере таблицы. -->
<template>
  <a
    v-if="order?.id"
    :href="`/orders/${order.id}`"
    class="order-link-cell"
    target="_blank"
    rel="noopener noreferrer"
  >
    {{ label }}
  </a>
  <span v-else>—</span>
</template>

<script>
export default {
  name: "TableOrderLinkCell",

  props: {
    order: {
      type: Object,
      default: null,
    },
  },

  computed: {
    label() {
      return this.order.selector_name || `Заказ #${this.order.id}`;
    },
  },
};
</script>

<style scoped>
.order-link-cell {
  display: inline-block;
  padding: 6px 8px;
  border: 1px solid #dbeafe;
  border-radius: 6px;
  background: #eff6ff;
  color: var(--color-blue);
  text-decoration: none;
}
</style>
